import React from 'react'
import { Button, Card } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons'

interface Props {
  title: React.ReactNode
  subtitle?: React.ReactNode
  onBack: () => void
  /** Optional actions rendered on the right of the header (e.g. a Delete button) */
  extra?: React.ReactNode
  children: React.ReactNode
}

/**
 * Standard full-page chrome for a Master add/edit form: a back button, title,
 * and a Card wrapping the form. Replaces the old Modal container so every
 * Master edits on its own page instead of a popup.
 */
const MasterFormShell: React.FC<Props> = ({ title, subtitle, onBack, extra, children }) => (
  <div>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
        <Button icon={<ArrowLeftOutlined />} onClick={onBack}>Back</Button>
        <div>
          <h2 className="page-title" style={{ margin: 0 }}>{title}</h2>
          {subtitle && <p className="page-subtitle" style={{ margin: 0 }}>{subtitle}</p>}
        </div>
      </div>
      {extra}
    </div>
    <Card>{children}</Card>
  </div>
)

export default MasterFormShell
